import React from 'react';
import './RestrictionModal.css';

/**
 * Shared popup for competition restrictions:
 *  - variant="break": shown when the platform is between competitions
 *  - variant="limit": shown when a user has already entered the current competition
 *
 * Usage:
 *   <RestrictionModal
 *     open={!!restriction}
 *     variant={restriction?.variant}
 *     stampText={restriction?.stampText}
 *     message={restriction?.message}
 *     onClose={() => setRestriction(null)}
 *   />
 */
const RestrictionModal = ({ open, variant = 'break', stampText, message, onClose }) => {
  if (!open) return null;

  return (
    <div className="restriction-modal-overlay" onClick={onClose}>
      <div
        className="restriction-modal-paper"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        {stampText && (
          <div className={`restriction-modal-stamp restriction-modal-stamp--${variant}`}>
            {stampText}
          </div>
        )}

        <p className="restriction-modal-message">{message}</p>

        <button type="button" className="restriction-modal-close" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
};

export default RestrictionModal;